var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canShow)?_c('div',{staticClass:"qr-container"},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":_vm.QRCodeBase,"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])]),_c('div',{staticClass:"mask"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }